/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-array-index-key */

import React from 'react';
import styled from 'styled-components';
import Typography from '@ntuctech/devex-tangram/Typography';
import SvgAlert from '@ntuctech/devex-tangram/Icon/SvgAlert';
import Link from '@ntuctech/devex-tangram/Link';

import {
  SEPARATOR,
  STR_SEARCH_KEY,
  SUPPORT_LINK_NAME,
  SUPPORT_LINK_URL,
  SUPPORT_LINK_REPLACE_TEXT,
  LOGIN_LINK_REPLACE_TEXT,
  LOGIN_LINK_NAME,
} from '../../../constants';
import ParseError from '../../../services/parse-error';

import { usePageContext } from '../../PageContextProvider';
import { PAGE_CONTEXT } from '../../../constants/app-constants';

const defaultStyle = `
  display: flex;
  align-items: center;

  margin-top: -0.625rem;
  margin-bottom: 1rem;
  border-radius: 0.5rem;

  animation-name: displayError;
  animation-duration: 1s;
  transition: all 0.3s linear;

  @keyframes displayError {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  & p {
    display: inline-block !important;
  }

  & svg {
    flex: 0 0 1rem;
  }
`;

const ErrorSC = styled.div`
  ${defaultStyle}
  padding: 0.5rem;
  background: ${(props) => props.theme.ColorBackgroundErrorLight3};

  & .SSOError {
    color: ${(props) => props.theme.ColorFontError};
  }
  & .SSOError__icon {
    fill: ${(props) => props.theme.ColorFontError};
    margin-right: 0.375rem;
  }
`;

const InfoSC = styled.div`
  ${defaultStyle}
  padding: 0.5rem 0.75rem;
  background: ${(props) => props.theme.ColorBackgroundPrimaryLight3};
`;

const isInfo = (errorMessage) => {
  return (
    errorMessage.indexOf(SUPPORT_LINK_REPLACE_TEXT) >= 0 ||
    errorMessage.indexOf(LOGIN_LINK_REPLACE_TEXT) >= 0
  );
};

export default function Loader({ error }) {
  const { setPageContext } = usePageContext();
  const errorMessage = ParseError.parse(error);

  if (!errorMessage) return null;

  const goToSignin = () => {
    setPageContext(PAGE_CONTEXT.LOGIN);
  };

  const attachNextStepLink = (message) => {
    const errorAsArray = message.split(SEPARATOR);
    if (errorAsArray.length === 1) {
      return message;
    }
    return errorAsArray.map((str, _i) => {
      if (str === STR_SEARCH_KEY.SUPPORT_LINK) {
        return (
          <Link key={`link_${_i}`} href={SUPPORT_LINK_URL} target="_blank">
            {SUPPORT_LINK_NAME}
          </Link>
        );
      }
      if (str === STR_SEARCH_KEY.LOGIN_LINK) {
        return (
          <Link key={`link_${_i}`} href="#" onClick={goToSignin}>
            {LOGIN_LINK_NAME}
          </Link>
        );
      }
      return str;
    });
  };

  return isInfo(errorMessage) ? (
    <InfoSC>
      <Typography variant="body3" className="SSOInfo">
        {attachNextStepLink(errorMessage)}
      </Typography>
    </InfoSC>
  ) : (
    <ErrorSC>
      <SvgAlert size="s" className="SSOError__icon" />
      <Typography variant="body3" className="SSOError">
        {errorMessage}
      </Typography>
    </ErrorSC>
  );
}
